export default __webpack_public_path__ + "static/media/ic-remove-red.a09e378a.svg";